import React, { useEffect, useState } from "react";
import FringePage from "../../entities/FringePage";
import LoaderHelper from "../../utils/Loader/LoaderHelper";
import AuthService from "../../api/AuthService";
import { useAlert } from "../../context/AlertContext";

const Fringe = () => {
  const [fringe, setFringe] = useState([]);
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getFringe();
  }, []);
  const getFringe = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getAdmFringe();
      if (result?.success) {
        setFringe(result?.data?.fringes);

        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleFringe = async (name, tax, id) => {
    setLoading(true);
    try {
      const result = await AuthService.handleSupFringe(name, tax, id);
      if (result?.success === true) {
        getFringe();
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  const handleCreateFringe = async (name, tax, id) => {
    setLoading(true);
    try {
      const result = await AuthService.createFringe(name, tax, id);
      if (result?.success === true) {
        getFringe();
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };

  const handleDeleteFringe = async ( id) => {
    setLoading(true);
    try {
      const result = await AuthService.deleteFringe( id);
      console.log(result,"result---")
      if (result?.success === true) {
        getFringe();
        setLoading(false);
        showAlert(result?.message, "success");
        // console.log(result?.success,"new employe data ---")
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error?.message, "error");
    }
  };
  return (
    <>
      <FringePage
        fringes={fringe}
        handleFringe={handleFringe}
        loading={loading}
        handleCreateFringe={handleCreateFringe}
        handleDeleteFringe={handleDeleteFringe}
      />
    </>
  );
};

export default Fringe;
